export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/statements.worker.74b9dda7.worker.js");
}
